import { ICourseCertificate, ICreateCourseCertificate } from '@/types/courses';
import Modal from '@ui/modal/modal';
import Container from '@ui/container/container';
import Button from '@ui/buttons/button/button';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { awardEmail } from '../course-certificate/email-preview-body';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';

type CourseEmailPreviewModalProps = {
  certificate: ICourseCertificate | ICreateCourseCertificate | undefined;
  open: boolean;
  onRequestClose: () => void;
  channelIcon?: string | null;
  firstName?: string;
  lastName?: string;
  courseName?: string;
  bannerImage?: string | null;
};

function CourseEmailPreviewModal({
  certificate,
  open,
  onRequestClose,
  channelIcon,
  firstName = 'John',
  lastName = '',
  courseName = 'A Course',
  bannerImage,
}: CourseEmailPreviewModalProps) {
  const _bannerImage = bannerImage || 'https://assets.brandlive.com/assets/bl-platform/images/limelight-banner.webp';
  const _channelIcon = channelIcon || 'https://assets.brandlive.com/assets/bl-logo-sunset.png';

  return (
    <Modal
      open={open}
      backgroundColor="var(--gray-900)"
      contentWrapperClassName="radius-12"
      onRequestClose={onRequestClose}
      customSize={{
        width: '900px',
        height: '800px',
        minHeight: '300px',
        maxHeight: 'calc(100vh - 80px)',
        maxWidth: 'calc(100vw - 80px)',
      }}
      renderHeaderContent={() => (
        <Container background="var(--gray-900)" className="flex ai-center jc-flex-end padding-16 radius-12">
          <Button onClick={onRequestClose}>
            <Icon name={ICONS.CLOSE} size={16} color="var(--gray-600)" />
          </Button>
        </Container>
      )}
    >
      <Container background="var(--gray-900)" className="flex ai-center jc-center">
        <div
          style={{ width: 800, borderRadius: '12px' }}
          dangerouslySetInnerHTML={{
            __html: awardEmail(
              certificate?.email_body.base || '',
              _channelIcon,
              _bannerImage,
              firstName,
              lastName,
              courseName,
              'about:blank',
              getThemeColorCSSVariable(),
              getThemeColorContrastCSSVariable()
            ),
          }}
        />
      </Container>
    </Modal>
  );
}

export default CourseEmailPreviewModal;
